interface Step2Props {
  email: string;
}

const Step2 = ({ email }: Step2Props) => {
  return (
    <div className="w-100">
      <div className="text-center mb-10">
        <h1 className="text-gray-900 fw-bolder mb-6">Verifique seu e-mail</h1>
        <div className="text-gray-500 fw-semibold fs-7">
          Não recebeu o e-mail?
          <a className="link-primary fw-bold ms-1" href="#">
            Reenviar
          </a>
        </div>
      </div>
    </div>
  );
};

export default Step2;
